<template>
  <div v-if="error" class="text-yapred-500 dark:text-yapred-400" data-testid="inputerror">
    {{ t(label, [error.params.limit]) }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useI18n } from '@/plugins/i18n';
import { YapInputValidationError } from '@/components/form/types/yapInputValidationError';

const props = defineProps<{
  error?: YapInputValidationError;
}>();

const { t } = useI18n();

const label = computed(() => {
  switch (props.error?.keyword) {
    case 'enum':
    case 'pattern':
    case 'maxLength':
    case 'minLength':
      return 'dict.validation.invalidInput';
    case 'minimum':
      return 'dict.validation.numberAtLeast';
    case 'maximum':
      return 'dict.validation.numberAtMost';
    case 'minimumDate':
      return 'dict.validation.dateAtLeast';
    case 'maximumDate':
      return 'dict.validation.dateAtMost';
    case 'type':
      return props.error.params.type === 'number' ? 'dict.validation.numbers' : 'dict.validation.invalidInput';
    case 'required':
      return 'dict.validation.required';
    case 'custom':
      return props.error.message ?? 'dict.validation.invalidInput';
    default:
      return 'dict.validation.invalidInput';
  }
});
</script>
